import React, { useState } from "react";
import { SectionHeading } from "@/components/common/SectionHeading";
import { ReviewSummary } from "@/components/reviews/ReviewSummary";
import { ReviewList } from "@/components/reviews/ReviewList";
import { ReviewForm } from "@/components/reviews/ReviewForm";
import { ReviewAdminDialogs } from "@/components/reviews/ReviewAdminDialogs";
import { useReviews } from "@/hooks/useReviews";
import { useReviewAdmin } from "@/hooks/useReviewAdmin";
import { useAuth } from "@/context/AuthContext";

const PAGE = 6;

export function ReviewsSection({ product }) {
  const [sort, setSort] = useState("recent");
  const [rating, setRating] = useState(null);
  const [limit, setLimit] = useState(PAGE);
  const [writing, setWriting] = useState(false);
  const { user } = useAuth();
  const isAdmin = user?.role === "admin";
  const { data, isLoading, isFetching } = useReviews(product.handle, { sort, rating, limit, moderation: isAdmin });
  const admin = useReviewAdmin();

  const changeFilter = (r) => { setRating(r); setLimit(PAGE); };
  const changeSort = (s) => { setSort(s); setLimit(PAGE); };

  return (
    <section id="reviews" className="mt-20 scroll-mt-28 border-t border-border pt-14" data-testid="reviews-section">
      <SectionHeading eyebrow="Customer Reviews" title="Loved by the ÉLORA Community" />
      <div className="mt-10">
        <ReviewSummary summary={data?.summary} ratingFilter={rating} onFilter={changeFilter} onWrite={() => setWriting(true)} />
      </div>
      <div className="mt-12">
        <ReviewList
          items={data?.items}
          total={data?.total || 0}
          isLoading={isLoading || isFetching}
          hasMore={data?.has_more}
          onLoadMore={() => setLimit((l) => l + PAGE)}
          sort={sort}
          onSort={changeSort}
          ratingFilter={rating}
          onClearFilter={() => changeFilter(null)}
          admin={isAdmin ? admin : null}
        />
      </div>
      <ReviewForm product={product} open={writing} onOpenChange={setWriting} />
      {isAdmin && <ReviewAdminDialogs admin={admin} />}
    </section>
  );
}
